
const initialState = {
  value: "allow"
}

export function siteAccessReducer(state = initialState, action) {
  switch (action.type) {
    case 'SITE_ACCESS':
      return { ...state, value: action.payload }
    default:
      return state
  }
}